module.exports = __webpack_public_path__ + "media/images/default_product_card_image-b6aa44ce05fd4bafdbfd760568ca0967.jpg";